<div class="sponsor">
  <div class="marqueeO">
    <div class="box-move">
      @for (sponsor of sponsors; track sponsor) {
      <div class="logoMar">
        <img src="{{sponsor.icon}}" alt="{{sponsor.name}}" title="{{sponsor.name}}" />
      </div>
      }
    </div>
    <div class="box-move">
      @for (sponsor of sponsors; track sponsor) {
      <div class="logoMar">
        <img src="{{sponsor.icon}}" alt="{{sponsor.name}}" title="{{sponsor.name}}" />
      </div>
      }
    </div>
  </div>
</div>